module.exports = __webpack_public_path__ + "img/helpbox-8.75e9b22d.png";